import { mock } from './';

export function fetchSuccessMock() {
  return mock({
    error: false,
    message: 'FETCH_STATE_ERROR',
    amount: 116,
    paymentType: 'ATM 轉帳繳款',
    bankCode: '013',
    bankAccount: '2803052326840796',
    deadline: '2020/05/23',
    info: `
      跨行轉帳若非使用同銀行 ATM 櫃員機，須支付跨行手續費 15 元。<br>
      若使用第一銀行 ATM 櫃員機，請選擇「繳費」按鈕。<br>
      請務必於繳費期限內進行繳費。
    `,
  });
}
